<div class="back-button-container">
	<a routerLink="/" class="back-button">↩ {{ backButtonLabel }}</a>
</div>

<section class="library-page">
	<article class="library-card">
		<h1 class="library-title">{{ pageTitle }}</h1>

		<p class="library-introduction">
			{{ introduction }}
		</p>
		
		<div class="course-list">
			@for (course of courses; track course.route) {
				<section class="course-item">
					<h3>{{ course.title }}</h3>
					<br>
					<p>{{ course.summary }}</p>
					<a class="course-link" [routerLink]="course.route">{{ readMoreLabel }}</a>
				</section>
			}
		</div>
	</article>
</section>
